import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "event-timeline-advanced",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Assess live event performance, channel targets and anomalies at a glance.",
    domain: "events",
    visual: "Performance timeline",
    purposes: ["live"],
    audiences: ["analyst"],
  },
  layout: { kind: "content", skeleton: "table", ownsSkeleton: true },
  defaultLayoutClassName: "col-span-12",
};
